import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { EmailBanner } from "@/components/layout/EmailBanner";
import { AccessibilityWidget } from "@/components/layout/AccessibilityWidget";
import { SeoHead, normPath, useContent } from "@/lib/content";

export const AppLayout = () => {
    const { pathname } = useLocation();
    const { user } = useAuth();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    if (user?.must_change_password && pathname !== "/scegli-password") return <Navigate to="/scegli-password" replace />;

    return (
        <div className="min-h-screen flex flex-col">
            <SeoHead />
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-md focus:bg-edi-lime focus:text-edi-on-lime focus:px-4 focus:py-3 focus:font-semibold"
                data-testid="skip-link"
            >
                Vai al contenuto principale
            </a>
            <Header />
            <EmailBanner />
            <main id="main-content" tabIndex={-1} className="flex-1 outline-none">
                <Outlet />
            </main>
            <Footer />
            <AccessibilityWidget />
        </div>
    );
};

export const usePageTitle = (title) => {
    const { pathname } = useLocation();
    const { seo } = useContent();
    useEffect(() => {
        if (seo?.pages?.[normPath(pathname)]) return;
        document.title = (seo?.template || "%s | EDI Assessment AI").replace("%s", title);
    }, [title, pathname, seo]);
};
